import utils from './utils'
import consts from '@/utils/consts'
import Cryptojs from 'crypto-js/crypto-js'
import querystring from 'querystring'
import da from 'element-ui/src/locale/lang/da'

var protocol = window.location.protocol
var port = protocol === 'https:' ? process.env.HTTPS_PORT : process.env.HTTP_PORT

var _baseUrl = protocol + '//' + process.env.API_HOST + ':' + port + '/'
var fpUploadUrl = protocol + process.env.FP_URL
var _voteBaseUrl = 'https://' + process.env.VOTE_API_HOST + '/'

export default {
  getBaseUrl () {
    return _baseUrl
  },
  getFpUpload () {
    return fpUploadUrl
  },
  getFpToken (type) {
    return _baseUrl + 'fp/token?file_type=' + type
  },
  getDocServiceList () {
    return _baseUrl + 'systems/doc/services'
  },
  getDocDemoDetail (serviceCode, demoCode) {
    return _baseUrl + 'systems/doc/services/' + serviceCode + '/apps/' + demoCode
  },
  getConstants () {
    return _baseUrl + 'systems/consts/'
  },
  getAdminLoginInfo () {
    return _baseUrl + 'admins/login_info'
  },
  getAdminLogin () {
    return _baseUrl + 'login?refer_uri=' + window.location.hash.replace('#', '')
  },
  getAdminLogout () {
    return _baseUrl + 'login/logout'
  },
  getAdminList () {
    return _baseUrl + 'admins/'
  },
  getAdminCreate () {
    return _baseUrl + 'admins/new'
  },
  getAdminDetail (id) {
    return _baseUrl + 'admins/' + id
  },
  getRoleList () {
    return _baseUrl + 'roles/'
  },
  getRoleCreate () {
    return _baseUrl + 'roles/new'
  },
  getRoleDetail (id) {
    return _baseUrl + 'roles/' + id
  },
  getServiceList () {
    return _baseUrl + 'services/'
  },
  getServiceCreate () {
    return _baseUrl + 'services/new'
  },
  getServiceUpdate (serviceCode) {
    return _baseUrl + 'services/' + serviceCode
  },
  getServiceDelete (serviceId) {
    return _baseUrl + 'services/' + serviceId
  },
  getServiceSign (serviceCode) {
    return _baseUrl + 'services/' + serviceCode + '/gen_sign'
  },
  getServiceTokenChange (serviceCode) {
    return _baseUrl + 'services/' + serviceCode + '/acl_token'
  },
  getProjectList (productCode) {
    return _baseUrl + 'projects/'
  },
  getProductList () {
    return _baseUrl + 'products/'
  },
  getProductCreate () {
    return _baseUrl + 'products/new'
  },
  getAppList (serviceCode) {
    return _baseUrl + 'services/' + serviceCode + '/apps/'
  },
  getAppDetail (serviceCode, appCode, productCode) {
    return _baseUrl + 'services/' + serviceCode + '/apps/' + appCode + '?product_code=' + productCode
  },
  getAppCreate (serviceCode) {
    return _baseUrl + 'services/' + serviceCode + '/apps/new'
  },
  getAppOnline (serviceCode, appCode, productCode) {
    return _baseUrl + 'services/' + serviceCode + '/apps/' + appCode + '/online?product_code=' + productCode
  },
  getRevertPreview (serviceCode, appCode, productCode) {
    return _baseUrl + 'services/' + serviceCode + '/apps/' + appCode + '/revert?product_code=' + productCode
  },
  getDemoList (serviceCode) {
    return _baseUrl + 'services/' + serviceCode + '/app_demos/'
  },
  getDemoCreate (serviceCode) {
    return _baseUrl + 'services/' + serviceCode + '/app_demos/new'
  },
  getDemoDetail (serviceCode, demoCode) {
    return _baseUrl + 'services/' + serviceCode + '/app_demos/' + demoCode
  },
  getRequestInterface (serviceCode, appCode) {
    return _baseUrl + 'services/' + serviceCode + '/apps/' + appCode + '/data/fetch'
  },
  getTagList () {
    return _baseUrl + 'tags/'
  },
  getTagCreate () {
    return _baseUrl + 'tags/new'
  },
  getTagDetail (tag) {
    return _baseUrl + 'tags/' + tag
  },
  getGroupList () {
    return _baseUrl + 'groups/'
  },
  getGroupDetail (groupId) {
    return _baseUrl + 'groups/' + groupId
  },
  getGroupCreate () {
    return _baseUrl + 'groups/new'
  },
  getQueryStat () {
    return _baseUrl + 'stats/'
  },
  getAppTagList () {
    return _baseUrl + 'systems/app_tags/'
  },
  getVoteList () {
    return '/admin/instance_focus_show'
  },
  getVoteCreate () {
    return '/admin/instance_create'
  },
  getVoteUpdate () {
    return '/admin/instance_update'
  },
  getVoteDetail () {
    return '/admin/instance_message'
  },
  getVoteDelete () {
    return '/admin/instance_delete'
  },
  getVoteItemList () {
    return '/admin/vote_list'
  },
  getVoteItemDetail () {
    return '/admin/vote_info'
  },
  getVoteItemCreate () {
    return '/admin/vote_create'
  },
  getVoteItemUpdate () {
    return '/admin/vote_update'
  },
  getVoteRewardList () {
    return '/admin/show_reward'
  },
  getVoteRewardCreate () {
    return '/admin/instance_reward'
  },
  getVoteRewardUpdate () {
    return '/admin/reward_update'
  },
  getVoteRewardDelete () {
    return '/admin/reward_delete'
  },
  getVoteItemOnline () {
    return '/admin/vote_online'
  },
  getVoteItemOffline () {
    return '/admin/vote_offline'
  },
  getVoteAdminList () {
    return _baseUrl + 'admins/vote_admin_list'
  },
  getVoteAppFocus () {
    return '/admin/app_focus'
  },
  getVoteAppUnFocus () {
    return '/admin/app_unfocus'
  },
  getRewardUserList () {
    return '/admin/reward_user_list'
  },
  getVoteUserReward () {
    return '/admin/vote_reward_user'
  },
  getVoteItemPull () {
    return '/admin/pull_vote'
  },
  getVoteItemConfUpdate () {
    return _voteBaseUrl + 'admin/vote_global_config_update'
  },
  getVoteWholeStatistics () {
    return '/admin/statistics_whole_show'
  },
  getVoteWholeStatisticsExport () {
    return '/admin/statistics_whole_export'
  },
  getVoteItemStatistics () {
    return '/admin/statistics_item_show'
  },
  getVoteItemStatisticsExport () {
    return '/admin/statistics_item_export'
  },
  getVoteStatisticsUserList () {
    return '/admin/statistics_user_list'
  },
  getVoteUserStatistics () {
    return '/admin/statistics_user_show'
  },
  getVoteUserStatisticsExport () {
    return '/admin/statistics_user_export'
  },
  getVoteItemDetailStatistics () {
    return '/admin/statistics_item_detail'
  },
  getVoteItemDetailStatisticsExport () {
    return '/admin/statistics_item_detail_export'
  },
  getVoteItemTopStatistics () {
    return '/admin/statistics_item_top'
  },
  getVoteItemTotalTopStatistics () {
    return '/admin/statistics_item_total_top'
  },
  getCheatVote () {
    return '/admin/vote_operation'
  },
  getVotePhoneCode () {
    return _voteBaseUrl + 'user/phone/get'
  },
  getVotePhoneLogin () {
    return _voteBaseUrl + 'user/phone/login'
  },
  getUserVote () {
    return _voteBaseUrl + 'user/vote'
  },
  getWelcomeCategoryList () {
    return _baseUrl + 'new_systems/categorys'
  },
  getWelcomeCategoryCreate () {
    return _baseUrl + 'new_systems/create_category'
  },
  getWelcomeCategoryUpdate (categoryCode) {
    return _baseUrl + 'new_systems/' + categoryCode
  },
  getWelcomeCategoryDelete (categoryId) {
    return _baseUrl + 'new_systems/' + categoryId
  },
  getWelcomeServiceList () {
    return _baseUrl + 'new_services/'
  },
  getWelcomeServiceCreate () {
    return _baseUrl + 'new_services/new'
  },
  getWelcomeServiceUpdate (serviceCode) {
    return _baseUrl + 'new_services/' + serviceCode
  },
  getWelcomeServiceDetail (serviceCode) {
    return _baseUrl + 'new_services/' + serviceCode
  },
  getWelcomeServiceDelete (serviceId) {
    return _baseUrl + 'new_services/' + serviceId
  },
  getWelcomeDemoList (serviceCode) {
    return _baseUrl + 'new_services/' + serviceCode + '/app_demos/'
  },
  getWelcomeDemoCreate (serviceCode) {
    return _baseUrl + 'new_services/' + serviceCode + '/app_demos/new'
  },
  getWelcomeDemoUpdate (serviceCode, demoCode) {
    return _baseUrl + 'new_services/' + serviceCode + '/app_demos/' + demoCode
  },
  getWelcomeDemoDelete (serviceCode, demoCode) {
    return _baseUrl + 'new_services/' + serviceCode + '/app_demos/' + demoCode
  },
  getTemplateDetail (serviceCode) {
    return _baseUrl + 'template_services/' + serviceCode + '/template'
  },
  getTemplateCreate (serviceCode) {
    return _baseUrl + 'template_services/' + serviceCode + '/new'
  },
  getTemplateUpdate (serviceCode) {
    return _baseUrl + 'template_services/' + serviceCode
  },
  getTemplateByConsul (serviceCode) {
    return _baseUrl + 'template_services/' + serviceCode + '/consul_template'
  },

  fetchListData (vueObj, url, dataField, params, callback = null) {
    params = params || {}
    params.start = (vueObj.currentPage - 1) * vueObj.perPage
    params.span = vueObj.perPage
    let paramsStr = utils.urlEncode(params)
    vueObj.$ajax.get(url + paramsStr).then((data) => {
      if (!callback) {
        vueObj.items = data[dataField]
        vueObj.totalRows = data.total_num
      } else {
        callback(data)
      }
    }, (res) => {
      vueObj.handleError(res)
    })
  },
  detailData (vueObj, url, dataField, params, callback = null) {
    params = params || {}
    let paramsStr = utils.urlEncode(params)
    vueObj.$ajax.get(url + paramsStr).then((data) => {
      vueObj.data = data[dataField]
      if (callback) {
        callback()
      }
    }, (res) => {
      vueObj.handleError(res)
    })
  },
  createData (vueObj, url, data, routeTo) {
    vueObj.$ajax.post(url, data).then((res) => {
      vueObj.$message.info('创建成功')
      vueObj.$router.push({name: routeTo})
    }, (res) => {
      vueObj.handleError(res)
    })
  },
  updateData (vueObj, url, data, callback = null) {
    return vueObj.$ajax.put(url, data).then((res) => {
      vueObj.$message.info('更新成功')
      if (callback) {
        callback()
      }
    }, (res) => {
      vueObj.handleError(res)
    })
  },
  deleteData (vueObj, url, data, callback = null) {
    return vueObj.$ajax.delete(url, data).then((res) => {
      if (res.status === 'ok') {
        vueObj.$message.info('删除成功')
      } else {
        vueObj.$message.info(res.status)
      }
      if (callback) {
        callback()
      }
    }, (res) => {
      vueObj.handleError(res)
    })
  },

  getAdminDelete (id) {
    return _baseUrl + 'admins/' + id
  },

  fetchVoteListData (vueObj, path, dataField, params, oversea, callback = null) {
    params = params || {}
    params.page = vueObj.currentPage
    params.limit = vueObj.perPage
    let reqData = {
      path: path,
      type: oversea || process.env.NODE_ENV.slice(0, 3),
      method: 'GET',
      data: params
    }
    vueObj.$ajax.post(_baseUrl + 'vote_project', reqData).then((res) => {
      if (res.success) {
        if (!callback) {
          vueObj.items = res.data[dataField]
          vueObj.totalRows = res.data.total_num
        } else {
          callback(res.data)
        }
      } else {
        vueObj.handleError(res)
      }
    }, (res) => {
      vueObj.handleError(res)
    })
  },
  detailVoteData (vueObj, path, method, dataField, params, oversea, callback = null) {
    params = params || {}
    let reqData = {
      path: path,
      type: oversea || process.env.NODE_ENV.slice(0, 3),
      method: method,
      data: params
    }
    vueObj.$ajax.post(_baseUrl + 'vote_project', reqData).then((data) => {
      vueObj.data = data[dataField]
      if (callback) {
        callback()
      }
    }, (res) => {
      vueObj.handleError(res)
    })
  },
  createVoteData (vueObj, path, method, data, oversea, callback = null, showMsg = true) {
    let reqData = {
      path: path,
      type: oversea || process.env.NODE_ENV.slice(0, 3),
      method: method,
      data: data
    }
    vueObj.$ajax.post(_baseUrl + 'vote_project', reqData).then((res) => {
      if (res.success) {
        if (showMsg) {
          vueObj.$message.info('创建成功')
        }
        if (callback) {
          callback()
        }
      } else {
        vueObj.handleError(res)
      }
    }, (res) => {
      vueObj.handleError(res)
    })
  },
  updateVoteData (vueObj, path, method, data, oversea, callback = null, showMsg = true) {
    let reqData = {
      path: path,
      type: oversea || process.env.NODE_ENV.slice(0, 3),
      method: method,
      data: data
    }
    return vueObj.$ajax.post(_baseUrl + 'vote_project', reqData).then((res) => {
      if (res.success) {
        if (showMsg) {
          vueObj.$message.info('更新成功')
        }
        if (callback) {
          callback()
        }
      } else {
        vueObj.handleError(res)
      }
    }, (res) => {
      vueObj.handleError(res)
    })
  },
  deleteVoteData (vueObj, path, method, data, oversea, callback = null) {
    let reqData = {
      path: path,
      type: oversea || process.env.NODE_ENV.slice(0, 3),
      method: method,
      data: data
    }
    return vueObj.$ajax.post(_baseUrl + 'vote_project', reqData).then((res) => {
      if (res.success) {
        vueObj.$message.info('删除成功')
        if (callback) {
          callback()
        }
      } else {
        vueObj.handleError(res)
      }
    }, (res) => {
      vueObj.handleError(res)
    })
  },
  voteHandler (vueObj, path, method, params, oversea, callback = null) {
    params = params || {}
    params.page = vueObj.currentPage
    params.limit = vueObj.perPage
    let reqData = {
      path: path,
      type: oversea || process.env.NODE_ENV.slice(0, 3),
      method: method,
      data: params
    }
    vueObj.$ajax.post(_baseUrl + 'vote_project', reqData).then((res) => {
      if (res.success) {
        if (callback) {
          callback(res)
        }
      } else {
        vueObj.handleError(res)
      }
    }, (res) => {
      vueObj.handleError(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/api.js